module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/Hashitate-83bd3f24f7b5452e7f0989b30542199b.jpg";